module.exports = __webpack_public_path__ + "img/cakes.611a347b.jpeg";